export default "__VITE_ASSET__dab028dc__"